import React from "react";
import { Header } from "../components";
import View from "../components/Moisaco/View";

const Mosaico = () => {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Home page" title="Mosaico" />
      <View />
    </div>
  );
};

export default Mosaico;
